import {
  type DateData,
  Calendar as RNCalendar,
  type CalendarProps as RNCalendarProps,
} from 'react-native-calendars';
import { StyleSheet, withUnistyles } from 'react-native-unistyles';
import useThemeStore from '@/stores/useThemeStore';
import { selectionAsync } from '@/utils/Haptics';
import Icon from '../Unistyles/Icon';

const UnistylesCalendar = withUnistyles(RNCalendar, (theme) => {
  return {
    theme: {
      calendarBackground: 'transparent',
      arrowColor: theme.colors.typography,
      dayTextColor: theme.colors.typography,
      textDisabledColor: theme.colors.typographyMuted,
      monthTextColor: theme.colors.typography,
      selectedDayBackgroundColor: theme.colors.info,
      todayTextColor: theme.colors.info,
      todayButtonTextColor: theme.colors.info,
      dotColor: theme.colors.primary,
      selectedDotColor: theme.colors.typography,
    },
    renderArrow: (direction: string) => (
      <Icon
        name={
          direction === 'left'
            ? 'chevron-back-outline'
            : 'chevron-forward-outline'
        }
        color={theme.colors.typography}
        size="2xl"
      />
    ),
  };
});

export default function Calendar(props: RNCalendarProps) {
  const { markedDates, onDayPress, ...restProps } = props;
  const theme = useThemeStore((state) => state.realTheme);

  return (
    <UnistylesCalendar
      key={`calendar-${theme}`}
      hideExtraDays
      markedDates={markedDates}
      onDayPress={(date: DateData) => {
        selectionAsync();

        if (onDayPress) {
          onDayPress(date);
        }
      }}
      style={style.container}
      {...restProps}
      enableSwipeMonths={false}
    />
  );
}

const style = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 400,
    alignSelf: 'center',
    borderRadius: 8,
  },
});
